function RedirectPage() {
    window.location.href = "https://carty.com.br/landpage/";
    return null;
}
export default RedirectPage;